import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';

const NAV = [
  { to: '/master',           label: 'Dashboard',   icon: '📊', end: true },
  { to: '/master/leads',     label: 'Leads',       icon: '🎯' },
  { to: '/master/tenants',   label: 'Clientes',    icon: '🏢' },
  { to: '/master/billing',   label: 'Faturamento', icon: '💰' },
  { to: '/master/campaigns', label: 'Campanhas',   icon: '🔥' },
  { to: '/master/blog',      label: 'Blog',        icon: '✍️' },
  { to: '/master/admins',    label: 'Masters',     icon: '🛡️' },
  { to: '/master/system',    label: 'Sistema',     icon: '⚙️' },
];

export default function MasterLayout() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const initial = user?.name?.[0]?.toUpperCase() || 'M';

  return (
    <div className="app-layout">
      {/* Overlay for mobile sidebar */}
      <div
        className={`mobile-overlay${mobileOpen ? ' active' : ''}`}
        onClick={() => setMobileOpen(false)}
      />

      <aside className={`sidebar${mobileOpen ? ' mobile-open' : ''}`}>
        <div className="sidebar-brand">
          <div className="logo-row">
            <img src="/logo.svg" alt="AtendoApp" className="logo-img" />
            <div>
              <h2>AtendoApp</h2>
              <div className="subtitle">Master Admin</div>
            </div>
          </div>
        </div>
        <nav className="sidebar-nav">
          <span className="sidebar-section-label">Painel Master</span>
          {NAV.map(item => (
            <NavLink
              key={item.to} to={item.to} end={item.end}
              className={({ isActive }) => `sidebar-nav-item${isActive ? ' active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>{item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{initial}</div>
            <div className="user-info-text">
              <small>Master Admin</small>
              <strong>{user?.name}</strong>
            </div>
          </div>
          <button className="btn-theme" onClick={toggleTheme}>
            {theme === 'dark' ? '☀️ Modo claro' : '🌙 Modo escuro'}
          </button>
          <button className="btn-logout" onClick={logout}>Sair do sistema</button>
        </div>
      </aside>

      <div className="main-content">
        {/* Mobile top bar */}
        <div className="mobile-header">
          <button className="hamburger" onClick={() => setMobileOpen(o => !o)} aria-label="Menu">
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="/logo.svg" alt="AtendoApp" style={{ height: 28, objectFit: 'contain' }} />
            <span style={{ fontWeight: 700, fontSize: 16, color: 'var(--gray-900)' }}>Master</span>
          </div>
          <div style={{ width: 44 }} />
        </div>

        <Outlet />

        {/* Bottom Navigation (mobile only) */}
        <nav className="bottom-nav" aria-label="Navegação Master">
          {NAV.map(item => (
            <NavLink
              key={item.to} to={item.to} end={item.end}
              className={({ isActive }) => `bottom-nav-item${isActive ? ' active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              <span className="bnav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
